<template>
  <div class="Article Container">
    <router-view></router-view>
  </div>
</template>

<script>
  import device from 'current-device';

  export default {
    name: 'Wiki',
    metaInfo() {
      return {
        bodyAttrs: {
          class: device.mobile() ? 'is-mobile' : '',
        },
      };
    },
  };
</script>

<style lang="scss">
  .is-mobile {
    .Header, .PageHeader, .Footer {
      display: none;
    }
    .Content {
      margin: 0;
    }
    .Container {
      width: auto;
      min-width: auto;
    }
    .Article {
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  .Article {
    padding: 30px 0 60px 0;
    h1 {
      font-size: 24px;
      margin-bottom: 30px;
      font-weight: 700;
    }
    h2 {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 20px;
      font-size: 14px;
    }
    img {
      max-width: 90%;
    }
    .center {
      text-align: center;
    }
  }
</style>
